
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class JobPaymentStatusDisplay extends Vue {
  @Prop({ required: true }) readonly label!: string;
  @Prop({ required: true }) readonly status!: string;

  readonly startStatus = 'Pending';
  readonly holdStatus = 'On Hold';
  get finalStatus(): string {
    return this.label.toUpperCase().includes('INVOICE') ? 'Invoiced' : 'Paid';
  }

  get displayText(): string {
    if (this.status.toUpperCase() === this.startStatus.toUpperCase()) {
      return this.startStatus;
    } else if (this.status.toUpperCase() === this.holdStatus.toUpperCase()) {
      return this.holdStatus;
    } else if (this.status.toUpperCase() === this.finalStatus.toUpperCase()) {
      return this.finalStatus;
    } else {
      return this.startStatus;
    }
  }

  get displayIcon(): string {
    if (this.status.toUpperCase() === this.startStatus.toUpperCase()) {
      return 'mdi-information';
    } else if (this.status.toUpperCase() === this.holdStatus.toUpperCase()) {
      return 'mdi-dots-horizontal-circle';
    } else if (this.status.toUpperCase() === this.finalStatus.toUpperCase()) {
      return 'mdi-check-circle';
    } else {
      return 'mdi-information';
    }
  }

  get displayIconColor(): string {
    if (this.status.toUpperCase() === this.startStatus.toUpperCase()) {
      return 'purple';
    } else if (this.status.toUpperCase() === this.holdStatus.toUpperCase()) {
      return 'orange';
    } else if (this.status.toUpperCase() === this.finalStatus.toUpperCase()) {
      return 'lime';
    } else {
      return 'purple';
    }
  }
}
